export default __webpack_public_path__ + "static/media/thumb09_poster@2x.89e73041.png";